import ServiceCRUD from '../../../../services/ServiceGasOrder';

class OpportunityService extends ServiceCRUD {
  constructor() {
    super(`/api/oportunidades`);
  }
}

export default new OpportunityService();
